export default "__VITE_ASSET__C9qY6lKr__"